import { render, staticRenderFns } from "./DynamicWidget.vue?vue&type=template&id=2267b6a0&"
import script from "./DynamicWidget.vue?vue&type=script&lang=js&"
export * from "./DynamicWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports